// extracted by mini-css-extract-plugin
export var createdDate = "_m8-1";
export var divider = "_m8-2";
export var headerDivider = "_m8-3";
export var messagesCard = "_m8-0";
export var messagesContainer = "_m8-6";
export var messagesContainerWrapper = "_m8-4";
export var showLeftPanelButton = "_m8-8";
export var topButtons = "_m8-7";
export var withPadding = "_m8-5";